import Footer from "@/components/Footer";
import Navbar from "@/components/Navbar";
import React from "react";

const TermsConditions = () => {
  return (
    <>
      <Navbar />
      <div className="min-h-screen bg-white">
        {/* HERO */}
        <section className="py-20 bg-emerald-900 text-white text-center">
          <h1 className="text-5xl font-bold mb-4">Terms & Conditions</h1>
          <p className="text-emerald-100 max-w-2xl mx-auto">
            Please read these terms carefully before using our services.
          </p>
        </section>

        {/* CONTENT */}
        <section className="max-w-5xl mx-auto px-6 py-16 space-y-10 text-gray-700">
          <div>
            <h2 className="text-2xl font-bold mb-2">1. Acceptance of Terms</h2>
            <p>
              By accessing our website, you agree to comply with and be bound by
              these terms and conditions.
            </p>
          </div>

          <div>
            <h2 className="text-2xl font-bold mb-2">2. Services</h2>
            <p>
              We provide agro-export services including sourcing and
              international delivery of agricultural products.
            </p>
          </div>

          <div>
            <h2 className="text-2xl font-bold mb-2">3. Pricing & Payment</h2>
            <p>
              All pricing is subject to change without notice. Payments must be
              completed as per agreed contracts.
            </p>
          </div>

          <div>
            <h2 className="text-2xl font-bold mb-2">4. Liability</h2>
            <p>
              We are not responsible for delays caused by customs, shipping, or
              external logistics providers.
            </p>
          </div>

          <div>
            <h2 className="text-2xl font-bold mb-2">5. Changes to Terms</h2>
            <p>
              We reserve the right to update these terms at any time without
              prior notice.
            </p>
          </div>
        </section>
      </div>
      <Footer />
    </>
  );
};

export default TermsConditions;
